const datePick = function (date) {
  if (date) {
    const Y = date.getFullYear() + "-";
    const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
    const D = (date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate());
    return Y + M + D;
  }
  return null;
};
const comdify = function (n) {
  if (!n) {return n;}
  const str = n.split(".");
  const re = /\d{1,3}(?=(\d{3})+$)/g;
  str[0] = str[0].replace(/[^\d]/g, "");
  const n1 = str[0].replace(re, "$&,");
  return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}`;
};
// 去除千分位中的‘，'
const delcommafy = function (num) {
  if (!num) {return num;}
  num = num.toString();
  num = num.replace(/,/gi, "");
  return num;
};
// 時間格式化
const time = function (date) {
  let fmt = "YYYY-mm-dd HH:MM:SS";
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(),
    "m+": (date.getMonth() + 1).toString(),
    "d+": date.getDate().toString(),
    "H+": date.getHours().toString(),
    "M+": date.getMinutes().toString(),
    "S+": date.getSeconds().toString()
  };
  for (const k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")));
    }
  }
  return fmt;
};
// 時間格式化
const Qrcodetime = function (date) {
  let fmt = "YYYYmmddHHMMSS";
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(),
    "m+": (date.getMonth() + 1).toString(),
    "d+": date.getDate().toString(),
    "H+": date.getHours().toString(),
    "M+": date.getMinutes().toString(),
    "S+": date.getSeconds().toString()
  };
  for (const k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")));
    }
  }
  return fmt;
};
// 数组转换
const numChange = function (num) {
  switch (num) {
    case 1 : {
      num = "一";
      break;
    }
    case 2 : {
      num = "二";
      break;
    }
    case 3 : {
      num = "三";
      break;
    }
    case 4 : {
      num = "四";
      break;
    }
    case 5 : {
      num = "五";
      break;
    }
    case 6 : {
      num = "六";
      break;
    }
    case 7 : {
      num = "七";
      break;
    }
    case 8 : {
      num = "八";
      break;
    }
    case 9 : {
      num = "九";
      break;
    }
    case 0 : {
      num = "零";
      break;
    }
  }
  return num;
};
export default {
  datePick,
  comdify,
  delcommafy,
  time,
  Qrcodetime,
  numChange
};